import { Button, Modal, Form } from 'react-bootstrap';
import React, {useState, useContext} from 'react';
import Swal from 'sweetalert2';
import UserContext from '../UserContext';
import { Navigate } from 'react-router-dom';

export default function RegisterStudents() {
	const {user} = useContext(UserContext);

	// store values of input fields
	const [LRN, setLRN] = useState('');
	const [firstName, setFirstName] = useState('');
	const [middleName, setMiddleName] = useState('');
	const [lastName, setLastName] = useState('');
	const [sex, setSex] = useState('');
	const [grade, setGrade] = useState('');
	const [section, setSection] = useState('');
	const [password, setPassword] = useState('');


	//state for editCourse Modals to open/close
	const [showEdit, setShowEdit] = useState(false)

	//function for opening the modal
	const openEdit = () => {
		setShowEdit(true)
	}

	const closeEdit = () => {
		setShowEdit(false);
	}

   const registerUser = (event) =>{
    	
    	event.preventDefault();
    	
    	Swal.fire({
		    title: `Confirm Registration of new member`,
		    text: `Are you sure you want to add ${lastName}, ${firstName}?`,
		    icon: 'warning',
		    showCancelButton: true,
		    confirmButtonText: 'Yes, confirm',
		    cancelButtonText: 'Cancel',
		    reverseButtons: true
		  }).then((result) => {
		    
		    if (result.isConfirmed) {

				// fetch('http://localhost:4000/users/register', {
				fetch('https://gnhs2023ssgelection.herokuapp.com/students/register', {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({
						LRN:LRN,
						password:"gnhs2023ssgelection",
						firstName:firstName,
						middleName:middleName,
						lastName:lastName,
						sex:sex,
						grade:grade,
						section:section
					})
				})
				.then(response => response.json())
				.then(data => {
					console.log(data)
					if (data === true){

						Swal.fire({
						  title: 'Good job!',
						  text: 'Registration successful! User may now vote',
						  icon:'success'
						})
						
						setLRN('');
						setPassword('');
						setFirstName('');
						setMiddleName('');
						setLastName('');
						setSex('');
						setSection('');
						setGrade('');
						// navigate('/')
					} else{
						Swal.fire({
						  title: 'Error',
						  text: 'Contact IT Admin',
						  icon:'error'
						})
					}
				})			
		    }else{
		    	setShowEdit(false);
		    }
		  })

   }
  
	
	

	return(
	  	(user.accessToken === null) ?
						
			<Navigate to="/" />
		:
			<>
				<Button className= " p-2 m-1 mb-3" variant="danger"  onClick={() => openEdit()}>Register Voter</Button>	
			{/*Edit Modal Forms*/}
				<Modal show={showEdit} onHide={closeEdit}>
					<Form onSubmit={event => registerUser(event)}>
						<Modal.Header closeButton>
							<Modal.Title>Register User </Modal.Title>
						</Modal.Header>

						<Modal.Body>
					
							<Form.Group>
								<Form.Label>LRN</Form.Label>
								<Form.Control 
									placeholder = "ex: 673439"
									required
									value={LRN}
									type="number"
									onChange={e => setLRN(e.target.value)}
								/>
							</Form.Group>
							<Form.Group>
								<Form.Label>Password</Form.Label>
								<Form.Control 
									placeholder = "ex: sdaswew2323"
									required
									value={password}
									type="text"
									onChange={e => setPassword(e.target.value)}
								/>
							</Form.Group>

							<Form.Group>
								<Form.Label>First Name</Form.Label>
								<Form.Control 
									placeholder = "ex: Juan"
									required
									value={firstName}
									onChange={e => setFirstName(e.target.value)}
								/>
							</Form.Group>
							<Form.Group>
								<Form.Label>Middle Name</Form.Label>
								<Form.Control 
									placeholder = "ex: Dela Cruz"
									required
									value={middleName}
									onChange={e => setMiddleName(e.target.value)}
								/>
							</Form.Group>

							<Form.Group>
								<Form.Label>Last Name</Form.Label>
								<Form.Control 
									placeholder = "ex: Dela Cruz"
									required
									value={lastName}
									onChange={e => setLastName(e.target.value)}
								/>
							</Form.Group>	
							<Form.Group>
								<Form.Label>Sex</Form.Label>
								<Form.Control
									as="select"	 
									required
									value={sex}
									onChange={e => setSex(e.target.value)}
								>		
								  <option>Select here</option>
								  <option value="Male">Male</option>
								  <option value="Female">Female</option>
								</Form.Control>
								
							</Form.Group>

							<Form.Group>
								<Form.Label>Grade</Form.Label>
								<Form.Control 
									placeholder = "7"
									required
									type="number"
									value={grade}
									onChange={(e) => {
								      const input = e.target.value;
								      if (/^\d{0,12}$/.test(input)) {
								        setGrade(input);
								      }
								    }}
								    maxLength="11"
								/>
							</Form.Group>
							<Form.Group>
								<Form.Label>Section</Form.Label>
								<Form.Control 
									placeholder = "STEM 11-2"
									required
									value={section}
									onChange={e => setSection(e.target.value)}
								/>
							</Form.Group>

							
			         </Modal.Body>
						<Modal.Footer>
							<Button variant="secondary" onClick={closeEdit}>Close</Button>
							<Button variant="primary" type="submit">Submit</Button>
						</Modal.Footer>
					</Form>
					
				</Modal>
			</>
	)
}
